import { render } from "./ResultsValue.vue?vue&type=template&id=b2421874&scoped=true"
import script from "./ResultsValue.vue?vue&type=script&lang=ts"
export * from "./ResultsValue.vue?vue&type=script&lang=ts"

import "./ResultsValue.vue?vue&type=style&index=0&id=b2421874&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b2421874"

export default script